import { useState, useEffect } from 'react'
import { getEmpsUsernameAPI } from '../services/employee'

function UseEmpsUsername(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getEmpsUsernameAPI({
        orgId,
        searchs,
        // page: 1,
        // size: 20
      })
      if (!result) return

      const newData = result.result && result.result.map((d, i) => {
        return { value: d.username, label: d.username }
      })

      setData(newData)
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseEmpsUsername
